import {
  CELL_TYPE_THUMBNAIL,
  CELL_TYPE_POSTER,
  CELL_TYPE_CIRCLE,
  CELL_TYPE_LAUNCHER,
  CELL_TYPE_AUTOPLAY
} from '@/common/constant'
const Multiply = 3

export const getBandTypeInfoByCellType = (cellType) => {
  if (cellType === '') return
  const number = Number(cellType.match(/\d+/g)[0])
  let res = {
    type: '',
    typeNumber: '',
    width: '',
    height: '',
    cellType: 'band_' + number,
    componentName: ''
  }
  if (number < 8 || number === 52 || number === 82) {
    res.type = CELL_TYPE_THUMBNAIL
    res.width = 320 * Multiply
    res.height = 180 * Multiply
    res.typeNumber = 2
    res.componentName = 'LandscapeCell'
    res.loadingImageUrl = '/img/common/img_default_thum_2.png'
  } else if (number < 15 || number === 61 || number === 94 || number === 98) {
    res.type = CELL_TYPE_POSTER
    res.typeNumber = 1
    res.width = 104 * Multiply
    res.height = 156 * Multiply
    res.componentName = 'PortraitCell'
    res.loadingImageUrl = '/img/common/img_default_thum_1.png'
  } else if (number < 22) {
    res.type = CELL_TYPE_CIRCLE
    res.width = 160 * Multiply
    res.height = 90 * Multiply
    res.typeNumber = 3
    res.componentName = 'CircleCell'
    res.loadingImageUrl = '/img/common/img_default_thum_3.png'
  } else if (number === 31) {
    // 현재 사용하지 않음
    res.type = CELL_TYPE_LAUNCHER
    res.width = 36 * Multiply
    res.height = 36 * Multiply
    res.typeNumber = 4
  } else if (number === 82) {
    res.type = CELL_TYPE_AUTOPLAY
    res.width = 324 * Multiply
    res.height = 182 * Multiply
    res.typeNumber = 4
    res.componentName = 'landscape'
  }
  return res
}

export const getCellListContainerClassName = (cellType) => {
  if (cellType === CELL_TYPE_THUMBNAIL || cellType === CELL_TYPE_POSTER || cellType === CELL_TYPE_CIRCLE || CELL_TYPE_LAUNCHER) {
    return `cell-list scroll cell-${cellType}`
  }
}

export const getBandTypeInfoBySmrCellType = (cellType) => {
  switch (cellType) {
    case 'mainlist':
    case 'popularlist':
    case 'newlist' :
      return getBandTypeInfoByCellType('Band1')
    case 'clipPopularProgramList':
      return getBandTypeInfoByCellType('Band13')
  }
}
